import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
//import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-add-country',
    templateUrl: './add-country.component.html',
    styleUrls: ['./add-country.component.css'],
    standalone: false
})
export class AddCountryComponent {
  countryForm: any;
  // affList: any[] = [];
  countryList: any[] = [];
  affList: { aflType: any, aflName: any }[] = [];
  selectedCountry: string = '';
  selectedAffiliation: string = '';
  // @Input() data:any;
  citizen: any[] = [];
  filteredAffList: any[] = [];
  isDisabled = true;
  existing_affiliation:any[] = [];


  constructor(
    private dialogRef: MatDialogRef<AddCountryComponent>, private toast: ToastrService, private auth: AuthService, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder) {
    this.countryForm = this.fb.group({
      country: ['', Validators.required],
      affiliationType: ['', Validators.required],
      homeAddress: ['', Validators.required],
      mobile: ['', Validators.required],
      workAddress: [''],
      workNumber: [''],
      alternateNumber: ['']
    });
  }

  ngOnInit() {
    this.getCountries();
    this.getCitizenships();
    // console.log('data', this.data)
    // console.log('countryForm', this.countryForm.value)
    
    // if (this.data) {
    //   this.countryForm.patchValue({
    //     country: this.data.country,
    //     affiliationType: this.data.affiliation_type,
    //     homeAddress: this.data.home_address,
    //     mobile: this.data.mobile_phone,
    //     workAddress: this.data.work_address,
    //     workNumber: this.data.work_phone,
    //     alternateNumber: this.data.alt_phone
    //   });
    //   this.isDisabled = true;
    //   this.countryForm.get('country')?.disable(); //for current country
      
    //   this.selectedCountry = this.data.country;
    //   this.selectedAffiliation = this.data.affiliation_type;

    //   this.getAff(); //get affil types
    //   this.getAffiliationTypes(this.selectedCountry);
    // }
    if (this.data) {
      // Patch values later, after affList is loaded
      this.selectedCountry = this.data.country;

      // fetch affiliation types first
      this.auth.get_aff_type_con(this.selectedCountry).subscribe((res: any) => {
        this.affList = res.data.affiliations || [];
        // now patch value (because options exist)
        this.existing_affiliation = this.getExistingAffiliation(this.data.index)
        this.affList = this.affList.filter((aff: any) => {
          return !this.existing_affiliation.includes(aff.aflType);
        });
        this.countryForm.patchValue({
          country: this.data.country,
          affiliationType: this.data.affiliation_type,
          homeAddress: this.data.home_address,
          mobile: this.data.mobile_phone,
          workAddress: this.data.work_address,
          workNumber: this.data.work_phone,
          alternateNumber: this.data.alt_phone
        });
        this.isDisabled = true;
        this.countryForm.get('country')?.disable();
      });
    }
    else {
      this.getCitizenships();
    }
  }

  getCitizenships() {
    this.auth.get_citizenship().subscribe((res: any) => {
      const order = [
        'citizen_primary',
        'citizen_second',
        'citizen_third',
        'citizen_fourth'
      ];

      this.citizen = (res.data?.citizenships || []).sort((a: any, b: any) => {
        return order.indexOf(a.index) - order.indexOf(b.index);
      });

      // Extract existing countries
      const citizenCountries = this.citizen.map(item => item.country);
      this.getCountriesData(citizenCountries);

      // Extract existing affiliations
      // const existingAffiliations = this.citizen.map((item: any) => item.affiliation_type);
      // this.getFilteredAffiliations(existingAffiliations);
    });
  }

  getCountriesData(citizenCountries: string[] = []) {
    this.auth.getCountries().subscribe((res: any) => {
      if (!this.data)
        this.countryList = res.data.countries.filter(([value]: [string]) => {
          return value !== 'Select' && !citizenCountries.includes(value);
        });
    });
  }

   getExistingAffiliation(category:any)
	{ 
		for(let item in this.citizen)
		{
			if(category == "")
				this.existing_affiliation.push(this.citizen[item]['affiliation_type'])
			else
			{
				if(category != this.citizen[item]['index'])
					this.existing_affiliation.push(this.citizen[item]['affiliation_type'])
			}
		}
		return this.existing_affiliation		
	}

  getAff() {
    this.auth.get_aff_type_con(this.selectedCountry).subscribe((res: any) => {
      this.affList = res.data.affiliations;
      this.selectedAffiliation = this.data.affiliation_type;

          // Patch only after affList is loaded
    this.selectedAffiliation = this.data.affiliation_type;
      this.countryForm.patchValue({
        affiliationType: this.data.affiliation_type // "pr"
      });
    });
  }


  getCountries() {
    this.auth.getCountries().subscribe((res: any) => {
      if (!this.data)
        this.countryList = res.data.countries.filter(([value]: [string]) => value !== 'Select');
    });
  }

  onCountryChange(country: any) {
    this.selectedCountry = country;
    this.getAffiliationTypes(country); // Fetch affiliations based on selected country
  }

  //getAffiliationTypes(country: any) {
    // this.auth.get_aff_type_con(country).subscribe((res: any) => {
    //   this.affList = res.data.affiliations || [];
    // });
  //}

  getAffiliationTypes(country: any) {
    // Normalize 'citz' to 'pr'
    // const existingAffiliations = this.citizen.map((item: any) => {
    //   return item.affiliation_type === 'citz' ? 'pr' : item.affiliation_type;
    // });
     const existingAffiliations = this.citizen.map((item: any) => item.affiliation_type);
    // Now get affiliations for the given country
    this.auth.get_aff_type_con(country).subscribe((res: any) => {
      this.affList = res.data.affiliations.filter((aff: any) => {
        return !existingAffiliations.includes(aff.aflType);
      });

      // // Patch here
      // this.selectedAffiliation = this.data.affiliation_type;
      // this.countryForm.patchValue({
      //   affiliationType: this.data.aflName
      // });

      //console.log('--Filtered AffList:', this.affList);
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {    
    if (this.countryForm.valid) {
    // Enable the country field before submission
    this.countryForm.get('country')?.enable();
    const formValue = this.countryForm.value;
    const countryValue = formValue.country;
    this.countryForm.get('country')?.disable();
    //console.log('Form Value:', formValue);

      const {
        country,
        affiliationType,
        homeAddress,
        mobile,
        workAddress,
        workNumber,
        alternateNumber
      } = this.countryForm.value;

      const payload = {
        country: countryValue,
        affiliation_type: affiliationType,
        home_address: homeAddress,
        mobile_phone: mobile,
        work_address: workAddress,
        work_phone: workNumber,
        alt_phone: alternateNumber
      };
      
      // console.log('Submitting:', payload);

      const apiCall = this.data
        ? this.auth.edit_country(this.data.index, payload)
        : this.auth.add_country(payload);

      apiCall.subscribe({
        next: (res: any) => {
          if (res?.error === false) {
            this.toast.success(res.msg || (this.data ? 'Citizenship updated successfully.' : 'Citizenship created successfully.'));
            this.cancel();
          } else {
            this.toast.error(res?.msg || 'An unexpected error occurred.');
          }
        },
        error: (err: any) => {
          const fieldLabelMap: Record<string, string> = {
            work_phone: 'Work',
            mobile_phone: 'Mobile',
            alt_phone: 'Alternate',
            home_address: 'Home Address',
            work_address: 'Work Address',
            affiliation_type: 'Affiliation Type',
            country: 'Country',
          }; //field names

          if (err.status === 400) {
            if (err.error?.errors?.length) {
              const firstError = err.error.errors[0];
              // console.log(firstError)
              const readableField = fieldLabelMap[firstError.field] || firstError.field;
              const msg = firstError.msg?.replace(firstError.field, readableField) || 'Validation error.';
              this.toast.error(msg);

            } else if (err.error?.msg) {
              this.toast.error(err.error.msg); // Handles "Too many citizenships."
            } else {
              this.toast.error('Bad request.');
            }
          } else if (err.status === 409 && err.error?.msg) {
            this.toast.error(err.error.msg);
          } else {
            this.toast.error('Something went wrong. Please try again.');
          }
        }
      });

    } else {
      this.countryForm.markAllAsTouched();
      //console.log('Form invalid');
    }
  }

  // allowOnlyNumbers(event: KeyboardEvent) {
  //   const charCode = event.which ? event.which : event.keyCode;
  //   if (charCode < 48 || charCode > 57) {
  //     event.preventDefault();
  //   }
  // }
  // preventInvalidPaste(event: ClipboardEvent) {
  //   const pastedInput: string = event.clipboardData?.getData('text') ?? '';
  //   if (!/^\d+$/.test(pastedInput)) {
  //     event.preventDefault();
  //   }
  // }

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedChars = /[0-9()+\-]/;  // includes space
    const inputChar = event.key;

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    const allowedPattern = /^[0-9()+\-]+$/;  // includes space

    if (!allowedPattern.test(pastedInput)) {
      event.preventDefault();
    }
  }

  //prevent space at 1st position
  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;

    // If space is pressed at position 0, prevent it
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault();
    }
  }

  // allow only single space between words
  validateSpacesHome(event: Event) {
    const input = event.target as HTMLInputElement;
    // replace multiple spaces with single space
    input.value = input.value.replace(/\s{2,}/g, ' ');
    // if you're using reactive forms, update the control value:
    this.countryForm.get('homeAddress')?.setValue(input.value, { emitEvent: false });
  }
    
  validateSpacesWork(event: Event) {
    const input = event.target as HTMLInputElement;
    // replace multiple spaces with single space
    input.value = input.value.replace(/\s{2,}/g, ' ');
    // if you're using reactive forms, update the control value:
    this.countryForm.get('workAddress')?.setValue(input.value, { emitEvent: false });
  }

}
